import { memo } from 'react';
import { Map as ImmutableMap } from 'immutable';

import ShiftAlert from './ShiftAlert';

type MissedClockOutProps = {
  item: ImmutableMap<string, any>;
};

const MissedClockOut = ({ item, ...rest }: MissedClockOutProps) => (
  <ShiftAlert
    descI18n="notifications.alerts.clock_out.desc"
    item={item}
    {...rest}
  />
);

export default memo(MissedClockOut);
